module.exports = __webpack_public_path__ + "media/images/menu/galaxies-240be8c06c613e4dff439027dd7cae14.jpg";